import { type FormEvent, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import { login, loginErrorMessage } from "@shared/api/adminApi.ts";
import { Alert, Button } from "@shared/components/Button.tsx";
import { Field, TextInput } from "@shared/components/Field.tsx";
import { Logo } from "@shared/components/Logo.tsx";
import { useSessionToken } from "../Layout.tsx";

export function LoginPage() {
  const token = useSessionToken();
  const navigate = useNavigate();
  const loc = useLocation();
  const from = (loc.state as { from?: string } | null)?.from ?? "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  if (token) return <Navigate to={from} replace />;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      setError("ईमेल व पासवर्ड दोन्ही भरा.");
      return;
    }
    setBusy(true);
    setError(undefined);
    try {
      await login(email.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(loginErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <div className="login__stripe" aria-hidden="true" />
      <form className="login__card" onSubmit={submit} noValidate>
        <div className="login__brand">
          <Logo size={72} />
          <h1>प्रशासक लॉगिन</h1>
          <p>शिव-वक्ता स्पर्धा २०२६-२७ · छत्रपती सेवा प्रतिष्ठान, नागपूर-पुणे</p>
        </div>
        {error && <Alert tone="error">{error}</Alert>}
        {import.meta.env.VITE_USE_MOCK === "true" && (
          <Alert tone="info" title="डेमो मोड">
            ईमेल: admin@example.com · पासवर्ड: demo1234
          </Alert>
        )}
        <Field id="login_email" label="ईमेल" required>
          <TextInput
            id="login_email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
          />
        </Field>
        <Field id="login_password" label="पासवर्ड" required>
          <TextInput
            id="login_password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>
        <Button
          type="submit"
          size="lg"
          loading={busy}
          loadingText="लॉगिन होत आहे…"
          className="login__submit"
        >
          लॉगिन करा
        </Button>
        <p className="login__note">
          सत्र ४ तासांनंतर आपोआप संपते. प्रशासक खाती फक्त सर्व्हरवरून तयार केली
          जातात.
        </p>
      </form>
    </div>
  );
}
